export const DataType = {
  String: 0,
  Integer: 1,
};

export const Order = {
  asc: 0,
  desc: 1,
};

export const Operation = Object.freeze({
  EQUAL: 0,
  LIKE: 1,
});

export const ActivityConfigColumn = {
  date: 0,
  activity: 2,
  user: 3,
};

export const FileBrowserFilters = Object.freeze([
  {
    key: "FileName",
    value: "File Name",
    isDefault: true,
    dataType: DataType.String,
  },
  {
    key: "NewSWSapNumberVersion",
    value: "SW SAP Number and Version",
    dataType: DataType.String,
  },
]);

export const FileFilters = Object.freeze([
  {
    key: "FileName",
    value: "File Name",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "ReleaseNote", value: "Release Notes", dataType: DataType.String },
  {
    key: "NewSWSapNumberVersion",
    value: "SW SAP Number and Version",
    dataType: DataType.String,
  },
]);

export const BoundTo = Object.freeze({
  ProductNumber: { displayName: "Product Number", value: 0 },
  SerialNumber: { displayName: "Serial Number", value: 1 },
  CombinedProductAndSerialNumber: {
    displayName: "Combined Product and Serial Number",
    value: 2,
  },
  UnitFamilyTypeVersion: { displayName: "Unit Family Type Version", value: 3 },
});

export const ProductType = Object.freeze({
  Digital: { displayName: "Digital", value: 0 },
  Physical: { displayName: "Physical", value: 1 },
});

export const UsageLimitType = Object.freeze({
  Unlimited: { displayName: "Unlimited", value: 0 },
  PowerTimeInSeconds: { displayName: "Power Time in Seconds", value: 1 },
  OperatingTimeInSeconds: {
    displayName: "Operating Time in Seconds",
    value: 2,
  },
  MovedVolumeInCubicMeters: {
    displayName: "Moved Volume in Cubic Meters",
    value: 3,
  },
  ConsumedEnergyInJoule: { displayName: "Consumed Energy in Joule", value: 4 },
});

export const FormMode = Object.freeze({
  View: 0,
  Add: 1,
  Edit: 2,
});

export const LicensesListColumns = Object.freeze({
  product_name: 0,
  product_number: 1,
  package_name: 2,
  package_id: 3,
});

export const LicensesFilters = Object.freeze([
  {
    key: "ProductNumber",
    value: "Product Number",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "PackageId", value: "Package Id", dataType: DataType.Integer },
  { key: "PackageName", value: "Package Name", dataType: DataType.String },
]);

export const VouchersListColumns = Object.freeze({
  product_number: 0,
  duration: 1,
  usage_limit: 2,
  package_name: 3,
});

export const VouchersFilters = Object.freeze([
  {
    key: "Duration",
    value: "Duration",
    isDefault: true,
    dataType: DataType.Integer,
  },
  { key: "UsageLimit", value: "Usage Limit", dataType: DataType.Integer },
]);

export const VouchersOverviewListColumns = Object.freeze({
  voucher_code: 0,
  package_name: 1,
  last_activity: 2,
  purpose: 3,
  created_by: 4,
});

export const VouchersOverviewFilters = Object.freeze([
  {
    key: "VoucherCode",
    value: "Voucher Code",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "Purpose", value: "Purpose", dataType: DataType.String },
  { key: "CreatedBy", value: "Created By", dataType: DataType.String },
  { key: "LicensedTo", value: "Licensed To", dataType: DataType.String },
  { key: "ProductNumber", value: "Product Number", dataType: DataType.String },
]);

export const ExportFormats = Object.freeze({
  Pdf: { displayName: "Pdf", value: 0 },
  Excel: { displayName: "Excel", value: 1 },
});

export const VoucherStatus = Object.freeze({
  New: { displayName: "New", value: 0 },
  Redeemed: { displayName: "Redeemed", value: 1 },
  PartlyUsed: { displayName: "Partly Used", value: 2 },
  PartlyRegistered: { displayName: "Partly Registered", value: 3 },
  Used: { displayName: "Used", value: 4 },
  Registered: { displayName: "Registered", value: 5 },
  Invalid: { displayName: "Invalid", value: 6 },
});

export const Roles = Object.freeze({
  Admin: {
    displayName: "Admin",
    value: 1,
    permissions: Object.freeze({
      Users: { displayName: "User Management", value: 1 },
      FeatureKeys: { displayName: "Feature Key", value: 2 },
    }),
  },
  FirmwareManager: {
    displayName: "Firmware Manager",
    value: 2,
    permissions: Object.freeze({
      Configuration: { displayName: "Configuration", value: 3 },
      Firmwares: { displayName: "Firmware", value: 4 },
    }),
  },
  LicenseManager: {
    displayName: "License Manager",
    value: 3,
    permissions: Object.freeze({
      Licenses: { displayName: "License", value: 5 },
      DefineLicense: { displayName: "Define License", value: 6 },
      Entitlements: { displayName: "Voucher Overview", value: 7 },
      Vouchers: { displayName: "Voucher", value: 8 },
      VoucherSearch: { displayName: "Voucher Search", value: 11 },
      DefineVoucher: { displayName: "Define Voucher", value: 9 },
      ExportVoucher: { displayName: "Export Voucher", value: 10 },
    }),
  },
});

export const Navs = Object.freeze({
  Configuration: { path: "/configuration", display: "Configuration" },
  Firmwares: { path: "/firmwares", display: "Firmwares" },
  FeatureKeys: { path: "/feature-keys", display: "Feature Keys" },
  Licenses: { path: "/licenses", display: "Licenses" },
  Vouchers: { path: "/vouchers", display: "Vouchers" },
  Entitlements: { path: "/vouchers-overview", display: "Voucher Overview" },
  VoucherSearch: { path: "/voucher-search", display: "Voucher Search" },
  Users: { path: "/user-management", display: "User Management" },
});

export const getKeyByValue = (yourEnum, selectedValue) => {
  return Object.keys(yourEnum).find(
    (key) => yourEnum[key].value === selectedValue
  );
};

export const getKeyByDisplayName = (yourEnum, selectedDisplayName) => {
  return Object.keys(yourEnum).find(
    (key) => yourEnum[key].displayName === selectedDisplayName
  );
};
